module.exports = __webpack_public_path__ + "img/recharge.e79582ba.png";